import GroupListController from './group.list.controller';

export default {
    controller: GroupListController,
    template: require('./group.list.tpl.html')
};
